export const PRESS_KIT_PDF_PATH = "/dossier-de-presse.pdf";

export const PRESS_KIT_PDF_EMBED_URL = PRESS_KIT_PDF_PATH;

export const PRESS_KIT_PDF_DOWNLOAD_URL = PRESS_KIT_PDF_PATH;

export const PRESS_KIT_PDF_DOWNLOAD_NAME = "Dossier-de-presse-Les-Apprentis-Dictateurs.pdf";
